import PillButton from "@/app/shared/PillButton";
import AspectClearableLabel from "./AspectClearableLabel";

// AJB: need an apply button to close the menu?
export default function AspectToggle({
  label,
  icon,
  isSelected,
  onChange,
}: {
  label: string;
  icon: React.ReactNode;
  isSelected: boolean;
  onChange: (isSelected: boolean) => void;
}) {
  return (
    <PillButton
      startIcon={icon}
      onClick={() => onChange(!isSelected)}
      isSelected={isSelected}
    >
      <AspectClearableLabel label={label} isSelected={isSelected} />
    </PillButton>
  );
}
